import { Region } from '@/api/apis/resources/schedule';
import { CSAtHubFormSection, CSClinicalLeadsFormSection, CSOnCallFormSection } from '../sections';

type CSSchedulerSettingsInputsFormProps = {
  isReadOnly: boolean;
  regions: Region[];
};

export const CSSchedulerSettingsInputsForm = ({ regions, isReadOnly }: CSSchedulerSettingsInputsFormProps) => {
  return (
    <div className="flex flex-col">
      <div className="flex mb-5">
        <CSClinicalLeadsFormSection isReadOnly={isReadOnly} />
      </div>
      <div className="flex mb-5 gap-5">
        <div className="w-1/2">
          <CSOnCallFormSection isReadOnly={isReadOnly} regions={regions} />
        </div>
        <div className="w-1/2">
          <CSAtHubFormSection isReadOnly={isReadOnly} regions={regions} />
        </div>
      </div>
    </div>
  );
};
